import React, { useImperativeHandle } from 'react'
import { useFormik } from 'formik'

// components
import InputField from '../../../components/forms/InputField/InputField.component';
import FormSectionHeader from '../../../components/forms/FormSectionHeader/FormSectionHeader.component';
import AsyncSelectField from '../../../components/forms/AsyncSelectField/AsyncSelectField.component';

// apollo
import { GET_ALL_EQUIPMENT_CATEGORIES_FOR_SELECT_FIELD } from '../../../graphql/equipmentCategory/equipmentCategory.queries';

const classificationOptions = [
    { label: 'Unknown', value: 'UU'},
]

const AddEquipment = React.forwardRef(({ errors }, ref) => {
    useImperativeHandle(ref, () => ({
        getData: () => { return formik.values }
    }))

    const formik = useFormik({
        initialValues: {
            sku: '',
            name: '',
            category: '',
            itemWeightInLbs: '',
            description: '',
            quantity: ''
        },
        onSubmit: values=> {
            alert(JSON.stringify(values, null, 2));
        },
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <FormSectionHeader text='Basic Info' />
            <InputField 
                id="sku"
                placeholder="SKU"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.sku}
                isValid={errors['sku']}
            />

            <InputField 
                id="name"
                placeholder="Name"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.name}
                isValid={errors['name']}
            />

            <FormSectionHeader text='Specifications' />

            <AsyncSelectField 
                id="category"
                value={formik.values.category}
                placeholder="Category"
                onChange={value => formik.setFieldValue('category', value.value)}
                query={{
                    query: GET_ALL_EQUIPMENT_CATEGORIES_FOR_SELECT_FIELD,
                    rules: {
                        loopField: 'allEquipmentCategories',
                        label: ['name'],
                        value: 'id'
                    }
                }}
                required={true}
                isValid={errors['category']}
            />

            <InputField 
                id="itemWeightInLbs"
                placeholder="Weight per Piece (lbs.)"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.itemWeightInLbs}
                isValid={errors['itemWeightInLbs']}
            />

            <InputField 
                id="description"
                placeholder="Description"
                type="type"
                onChange={formik.handleChange}
                value={formik.values.description}
                isValid={errors['description']}
                required={false}
            />

            <InputField 
                id="quantity"
                placeholder="Initial Quantity"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.quantity}
                isValid={errors['quantity']}
            />

        </form>
    )
})

export default AddEquipment;